<template>
  <div>
    <div class="bg-white shadow rounded-lg overflow-hidden">
      <div class="flex">
        <div class="w-64 space-y-2 bg-gray-100 border-r border-gray-200">
          <ul class="divide-y divide-gray-200">
            <li
              v-for="metric in metrics"
              :key="metric.name"
              :class="[currentMetricName === metric.name ? 'bg-white -mr-px' : '']"
            >
              <label
                class="px-4 py-3 text-sm flex flex-1 space-x-2 items-center"
                v-tip="{ content: metric.description }"
              >
                <input
                  v-model="currentMetricName"
                  type="radio"
                  :value="metric.name"
                  class="hidden"
                />
                <span class="flex-1 truncate">
                  {{ metric.title }}
                </span>
              </label>
            </li>
          </ul>
        </div>
        <div class="flex-1">
          <div v-if="currentMetric" class="divide-y divide-gray-200">
            <MetricChartView
              :key="currentMetricName"
              :metric="currentMetric"
              :account-id="accountId"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MetricChartView from './metric-chart-view.vue';

export default {
  components: {
    MetricChartView,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      metrics: [
        {
          name: 'contacts_daily_cumulative_count',
          title: 'Contacts Count (Cumulative)',
          value: 'contacts_daily_cumulative_count',
          description:
            'Cumulative total number of new contacts each day within the specified range.',
        },
        {
          name: 'contacts_daily_count',
          title: 'Contacts Count',
          value: 'contacts_daily_count',
          description: 'Total number of new contacts each day within the specified range.',
        },
      ],
      currentMetricName: 'contacts_daily_cumulative_count',
    };
  },
  computed: {
    currentMetric() {
      return this.currentMetricName
        ? this.metrics.find((metric) => metric.name === this.currentMetricName) || null
        : null;
    },
  },
  methods: {
    //
  },
};
</script>
